import 'daterangepicker';
import moment from 'moment';

const isNil = val => val == null; // don't try this at home unless you know what you are doing

const $inputs = $('[data-filter-input]');
const $clearButtons = $('[data-js-clear-input]');
const $filtersCheckbox = $('[data-js-wallfilter-menu-burger-checkbox]');
const onInputChange = e => e.currentTarget && e.currentTarget.form.submit();

const DATE_FORMAT = 'DD/MM/YYYY';
const SUBMIT_FORMAT = 'DD-MM-YYYY';

const $pickerHidden = $('[data-filter-datepicker-hidden]');
const $picker = $('[data-filter-datepicker]').daterangepicker({
    autoUpdateInput: false,
    minDate: moment(),
    locale: {
        cancelLabel: 'Löschen',
        applyLabel: 'Übernehmen',
        format: DATE_FORMAT,
    },
});

// e vai di trunky funky qui!!!
// hammering hacks over hacks...
const pickerInternal = $picker.data('daterangepicker');

function init() {
    const origUpdateView = pickerInternal.updateView;
    pickerInternal.updateView = function() {
        // intercept all the update calls to make the client and the PMs happy
        // https://app.asana.com/0/137886543980536/1123375287609504
        if (!isNil(this.endDate) && !isNil(this.startDate)) {
            $picker.val(`${ this.startDate.format(DATE_FORMAT) } - ${ this.endDate.format(DATE_FORMAT) }`);
        }

        return origUpdateView.apply(this, arguments);
    };

    // the custom date picker events should be treated a bit differently
    $picker.on('apply.daterangepicker', function(ev, picker) {
        $pickerHidden.val(`${ picker.startDate.format(SUBMIT_FORMAT) },${ picker.endDate.format(SUBMIT_FORMAT) }`);
    }).on('cancel.daterangepicker', function(ev, picker) {
        $pickerHidden.val('');
    }).on('cancel.daterangepicker apply.daterangepicker', onInputChange).on('input', function() {
        if (!$(this).val()) {
            $pickerHidden.val('');
        }
    });

    $clearButtons.each((i, el) => {
        const $el = $(el);
        const $input = $(`[name=${ $el.attr('data-js-clear-input') }]`);
        const update = () => $el.toggle($input.val() !== '');
        $input.on('input', update);
        $el.on('click', e => {
            e.preventDefault();
            $input.val('');
            update();
            $input.focus();
        });
        update();
    });

    function toggleFilterLabel() {
        $(`[for="${ $filtersCheckbox.attr('id') }"]`).toggleClass('is-active', $filtersCheckbox.prop('checked'));
    }

    toggleFilterLabel();
    $filtersCheckbox.on('change', toggleFilterLabel);
    $inputs.on('change', onInputChange);
    $(window).on('keyup', e => e.keyCode === 13 && onInputChange({ currentTarget: $inputs.get(0) }));
}

if (pickerInternal) {
    init();
}

export default true;



// WEBPACK FOOTER //
// ./src/js/app/components/wallfilter.js